import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions } from '@angular/http'; //  Headers, RequestOptions
import { Subject, BehaviorSubject } from 'rxjs';
import { ExceptionText } from '../../helpers/exception-text';
import { TextResult } from '../../model/text-result';
import { Error } from '../../model/error';
import { Apollo } from 'apollo-angular';
import { getUserFromToken } from '../../queries/users.model';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Constants } from '../../helpers/constants';
import  { WindowRefService } from './window-ref.service';
// import { GetRequestsCount } from '../../queries/general.model';
// import { UserService } from './user.service';
// import { BackendRequestClass } from '../../backend.request';
const hostUrl = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_API_HOST : process.env.API_HOST;
const DIZZEE_LOGIN = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_DIZZEE_LOGIN : process.env.DIZZEE_LOGIN;
const DIZZEE_WHOAMI = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_DIZZEE_WHOAMI : process.env.DIZZEE_WHOAMI;
const DIZZEE_LOGOUT = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_DIZZEE_LOGOUT : process.env.DIZZEE_LOGOUT;

@Injectable()

export class AuthService {
  isLoggedIn: Subject<boolean>;
  private dizzeeToken: object;
  public userLoginObject: object;
  public userLoginType: string;
  public returnUrl: string;
  public ready: boolean;
  public userType:any;
  public loggedin: boolean;
  public appLoader: boolean = true;
  public termsRes: string = '';

  private _window: Window;

  constructor(
    private http: Http,
    private router: Router,
    private apollo:Apollo,
    // private userService: UserService,
    public windowRef: WindowRefService){
    this.isLoggedIn = new BehaviorSubject<boolean>(false);
    this._window = this.windowRef.nativeWindow;

  };



	// LOGIN TRIGGERED WHEN USER HITS /login route /////
  login() {
    this.loggedin = false;
    this.ready = false;
    let url = DIZZEE_WHOAMI;
   // initiate login checks and requests
    this.http.get(url, {withCredentials:true})
    .map((res: Response) => res)
    .subscribe(
      (data) => {
        let token;
        // console.log('data: ', data);
        if(data.status === 200) {
          this.loggedin = true;
          token = data.json();
          this.dizzeeToken = token.token;
          this.userObject();
          this.isLoggedIn.next(true);
        }
      },
      (err) => {
        // console.log('err: ', err);
        if(err.status === 401){
          this.loggedin = false;
          this.isLoggedIn.next(false);
          location.assign(DIZZEE_LOGIN);
        }
      }
    );
  }

  // public load() {
  //     this.http.get('http://localhost:5778/api/whoami?app=swiftDizzee').map( res => res.json()).subscribe( (callResult) => {
  //       this.result = callResult;
  //       console.log('result from backend service',this.result);
  //     },
  //       (err) => {
  //               // console.log('err: ', err);
  //               if(err.status === 401){
  //                 this.isLoggedIn.next(false);
  //                 location.assign(DIZZEE_LOGIN);
  //               }
  //             });
  //
  // }

  userObject(){
    return this.apollo.query({
      query: getUserFromToken,
      variables: {
        token: this.dizzeeToken,
        app: Constants.APPLICATIONNAME
      }
    }).subscribe((data) => {
      this.userLoginObject = data.data['getUserFromToken'];
      // console.log('user object from token', this.userLoginObject);
      this.userLoginType = this.userLoginObject['applications'][0].userType;
    }, (error) => {
      console.log('there was an error sending the query', error.message.split('error'));
    },() => {
      // this.getRequestCount().subscribe((data)=> {
      //   this.userService.requestCount = data['GetRequestsCount'];
      // });
      this.ready = true;
      let navigateTo;
      if (this.userLoginType === 'approver') {
        if(this.returnUrl && this.returnUrl !== '/list') {
          navigateTo = this.returnUrl;
        } else {
          navigateTo = '/external';
        }
      } else if (this.userLoginType === 'admin') {
        if (this.returnUrl) {
          navigateTo = this.returnUrl;
        } else {
          navigateTo = '/list';
        }
      }else {
        this.isLoggedIn.next(false);
        navigateTo = '/';
      }
      this.router.navigate([navigateTo]);
    });

  }

  logout() {
    this.dizzeeToken = null;
    this.userLoginObject = null;
    this._window.location.href = DIZZEE_LOGOUT;
  }

  // getRequestCount() {
  //   return this.apollo.query({
  //     query: GetRequestsCount
  //   }).map((({data}) => data))
  //     .catch((error) => {
  //       throw error;
  //     });
  // }

  generateOKTAToken(userProfile) {
    const promise = new Promise((resolve, reject) => {
      let body = JSON.stringify({ user: userProfile });
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      this.http.post(`${hostUrl}/api/okta/finalize`, body, options)
      .map(res => res.json())
      .subscribe(data => {
        if(data.status === 'ok') {
          const result = new TextResult();
          result.value = data.uri;
          resolve(result);
        } else {
          const error = new Error();
          error.message = data.message;
          reject(error);
        }
      }, err => {
        const error = new Error();
        error.message = ExceptionText.GENERAL_ERROR;
        reject(error);
        console.log(err);
      });
    });

    return promise;
  }

  acceptTerms(email, terms) {
    let dataUrl = `${hostUrl}/api/user/terms`;
    let userData = {
      email,
      terms
    };
    return this.http.post(dataUrl, userData)
      .map((res: Response) =>  res.json())
      .catch((error) => {
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/shared/services/auth.service.ts